import { GET_DURATION_SCAN_DROPOWN, GET_PROVINCE_SCAN_DROPOWN, GET_PURPOSE_SCAN_DROPOWN, GET_TRANSPORTATION_SCAN_DROPOWN } from "../../constants/queryKeys";
import { addFormScan, getDurationOfVisitScanDropDown, getProvinceScanDropDown, getPurposeOfVisitScanDropDown, getTransportationScanDown } from "../apiClient/formScan";
import { useQuery, useMutation } from "react-query"

export const useGetProvinceScanDropDown = ({ payload, config }) => {
    return useQuery([GET_PROVINCE_SCAN_DROPOWN, payload], () => getProvinceScanDropDown(payload), config);
};
export const useGetPurposeScanDropDown = ({ payload, config }) => {
    return useQuery([GET_PURPOSE_SCAN_DROPOWN, payload], () => getPurposeOfVisitScanDropDown(payload), config);
};
export const useGetDurationScanDropDown = ({ payload, config }) => {
    return useQuery([GET_DURATION_SCAN_DROPOWN, payload], () => getDurationOfVisitScanDropDown(payload), config);
};
export const useGetTransportationScanDropDown = ({ payload, config }) => {
    return useQuery([GET_TRANSPORTATION_SCAN_DROPOWN, payload], () => getTransportationScanDown(payload), config);
};

export const useAddFormScanMutation = (options) => {
  return useMutation((payload) => addFormScan(payload), options);
};
